import ActionType from 'actions/ActionType'

export default (state = { stage: null, event_type: null }, action) => {
	switch (action.type) {
    case ActionType.Campaign.ADD_OR_EDIT_EVENT_GOAL:
			return action.payload.event_type
				? action.payload
				: { stage: action.payload.stage, event_type: 'blank' }
		case ActionType.Campaign.ADD_EVENT_GOAL_TO_CAMPAIGN:
			return { stage: null, event_type: null }
		case ActionType.Campaign.RECEIVE_CAMPAIGN:
			return { stage: null, event_type: null }
		case ActionType.Campaign.EXPAND_FUNNEL_STAGE:
			return { stage: null, event_type: null }
		case ActionType.Campaign.REMOVE_NEW_EVENT_GOAL:
			return { stage: null, event_type: null }
		default:
			return state
	}
}
